import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import Small from 'UIComponents/elements/Small';
import UITableHoverCell from 'UIComponents/table/UITableHoverCell';
import UITableHoverContent from 'UIComponents/table/UITableHoverContent';
import FormattedDateTimeWithZones from 'automation-ui-i18n/FormattedDateTimeWithZones';
import UserName from 'automation-ui-references/customer-data/UserName';
import RevisionRollupInsetTable from 'automation-ui-management/revision-rollup-panel/RevisionRollupInsetTable';
import RevisionButton from 'automation-ui-management/components/revisions/RevisionButton';
import UITruncateString from 'UIComponents/text/UITruncateString';
import AuditEventRowMicrocopy from 'automation-ui-management/audit-history/AuditEventRowMicrocopy';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ExpandableTr = styled.tr.withConfig({
  displayName: "RevisionRollupRow__ExpandableTr",
  componentId: "sc-1eulukr-0"
})(({
  expanded
}) => `
  && {
    display: ${expanded ? 'table-row' : 'none'};
  }
  td:first-child {
    padding: 0;
  }
`);
const RevisionRollupRow = ({
  auditEvent,
  flowId,
  open,
  onOpenChange,
  onRevisionSelect
}) => {
  const eventType = auditEvent.getAuditEventType();
  const allEventTypes = auditEvent.getAllAuditEventTypes();
  const userId = auditEvent.getUserId();
  const timestamp = auditEvent.getTimestamp();
  const revisions = auditEvent.getRevisions();
  const isGroupedEvent = auditEvent.getIsGroupedEvent();
  const nonGroupedVersion = auditEvent.getFirstRevision().version;
  const handleRevisionSelect = onRevisionSelect ? () => onRevisionSelect(syntheticEvent(nonGroupedVersion)) : undefined;
  let message = /*#__PURE__*/_jsx(FormattedMessage, {
    message: `automation-ui-management.auditEvent.auditEventTypes.${eventType}`
  });
  if (allEventTypes.size > 1 && auditEvent.getIsEnrollmentEvent()) {
    message = allEventTypes.map(enrollmentEventType => I18n.text(`automation-ui-management.auditEvent.auditEventTypes.${enrollmentEventType}`).concat('.')).join(' ');
  }
  const UserChangesContent = /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    marginInlineStart: "300",
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UITruncateString, {
        children: /*#__PURE__*/_jsx(UserName, {
          id: userId || ''
        })
      })
    }), /*#__PURE__*/_jsx(UITruncateString, {
      children: /*#__PURE__*/_jsx(Small, {
        children: message
      })
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UITruncateString, {
        children: /*#__PURE__*/_jsx(AuditEventRowMicrocopy, {
          auditEvent: auditEvent
        })
      })
    })]
  });
  const UserChangesCell = /*#__PURE__*/_jsx(AccordionItem, {
    open: open,
    onOpenChange: value => {
      onOpenChange(value ? syntheticEvent(timestamp) : syntheticEvent(0));
    },
    flush: true,
    title: UserChangesContent
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("tr", {
      children: [isGroupedEvent ? /*#__PURE__*/_jsx("td", {
        children: UserChangesCell
      }) : /*#__PURE__*/_jsx(UITableHoverCell, {
        hoverContent: /*#__PURE__*/_jsx(UITableHoverContent, {
          children: /*#__PURE__*/_jsx(RevisionButton, {
            version: nonGroupedVersion,
            flowId: flowId,
            external: false,
            onClick: handleRevisionSelect
          })
        }),
        children: /*#__PURE__*/_jsx(Flex, {
          as: "div",
          marginInlineStart: "300",
          children: UserChangesContent
        })
      }), /*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
          useMultiline: true,
          value: timestamp,
          format: "lll z"
        })
      })]
    }), /*#__PURE__*/_jsx(ExpandableTr, {
      expanded: open,
      children: /*#__PURE__*/_jsx("td", {
        colSpan: 2,
        children: /*#__PURE__*/_jsx(RevisionRollupInsetTable, {
          revisions: revisions,
          onRevisionSelect: onRevisionSelect
        })
      })
    })]
  });
};
export default RevisionRollupRow;